var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvironment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,8.46c-1-.38-1.86-.7-2.78-.12a1.27,1.27,0,0,0-.62,1.32l2-1.08.24.68c-1.2.6-2.48,1.09-2.7,2.66l-.36,0c-.1,0-.19,0-.44,0,.59-1,.41-2.05.62-3.05a2.26,2.26,0,0,1,2.69-1.5A18.46,18.46,0,0,1,11.77,8c-.24,1.84-1.57,4-3.4,3,.26-.16.48-.42.69-.41.84,0,1.19-.52,1.51-1.12A10.25,10.25,0,0,0,11,8.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.7,5.14V4.5H6.07v.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.22,4.5v.64H6.84V4.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.72,5.91H6.07v.64H4.72Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.2,6.57H6.84V5.93H8.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.7,8V7.35H6.06V8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.7,9.41V8.78H6.06v.63Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.66,3.06H3.23v7.81h.4c.61,0,1.17,0,1.72,0s.77-.19.84-.75H4V3.79H9V6.57h.71V3.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironment);
export default __webpack_public_path__ + "static/media/environment.b2871c81fdfb6c1536409aa765c1bc72.svg";
export { ForwardRef as ReactComponent };